import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Configurable so these hidden paths can be changed later without touching code.
const ADMIN_LOGIN_PATH = process.env.REACT_APP_ADMIN_LOGIN_PATH || "/secure-admin-login";
const ADMIN_DASHBOARD_PATH = process.env.REACT_APP_ADMIN_DASHBOARD_PATH || "/secure-admin";

/**
 * `superOnly` — the route belongs to the Super Admin dashboard (/secure-admin).
 *   • Unauthenticated → bounce to /secure-admin-login.
 *   • Signed-in employee_admin → bounce to /admin (their own dashboard).
 *   • Signed-in retailer → bounce to /login (their own dashboard doesn't exist).
 * `adminOnly` — kept for backwards compat. Same rules as superOnly for now.
 * default — retailer-only pages. Signed-in staff are pushed to their dashboard.
 */
export default function ProtectedRoute({ children, adminOnly = false, superOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="font-serif text-brown text-lg">Loading…</div>
      </div>
    );
  }
  const wantsSuper = superOnly || adminOnly;

  if (!user) {
    return <Navigate to={wantsSuper ? ADMIN_LOGIN_PATH : "/login"} state={{ from: location }} replace />;
  }
  if (wantsSuper && user.role !== "admin") {
    // Employee admins go to their /admin dashboard; retailers to the storefront.
    const dest = user.role === "employee_admin" ? "/admin" : "/";
    return <Navigate to={dest} replace />;
  }
  return children;
}
